module.exports = __webpack_public_path__ + "img/usageHour.fad73481.png";